import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import routing from './sa_group_index.routes';
import SaGroupService from '../../../components/api/sa_group/sa_group.service';

export class SaGroupIndexController {
    /*@ngInject*/
    constructor(SaGroupService) {
        this.SaGroupService = SaGroupService;
    }

    $onInit() {
        this.SaGroupService.api.index(response => {
            this.groupList = response;
        });
    }
}

export default angular.module('leptonApp.saGroupIndex', [uiRouter, SaGroupService])
  .config(routing)
  .component('saGroupIndex', {
    template: require('./sa_group_index.html'),
    controller: SaGroupIndexController
  })
  .name;



// WEBPACK FOOTER //
// ./public/dev/app/sa_group/index/sa_group_index.component.js